export default function LandingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md text-center">
        <div className="text-6xl mb-6">🎯</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Welcome to Solace AI IQ Challenge</h1>
        <p className="text-gray-600 text-lg">
          Please reach out to your Solace contact for your quizzes URL
        </p>
      </div>
    </div>
  );
}
